<template>
  <div class="dashboard__card" v-cloak>
    <CardLoading v-if="loaders.vendors"></CardLoading>
    <div class="dashboard__card-content" :class="{ 'loadingBlur': loaders.vendors }">
      <div class="dashboard__card-header">
        <div class="dashboard__card-title">Pricing Guides</div>
        <div class="dashboard__card-title-icon dashboard__card-title-icon--library"><i class="fa fa-file"></i></div>
      </div>
      <div class="row dashboard__card-body">
        <div class="dashboard__grid dash-library__content-container" v-if="pricingVendors">
          <div class="col-xs-12 dashboard__card-body-col dashboard__card-body-col--bordered">
            <div class="dash-library__list">
              <Document v-for="(document, index) in pricingVendors" :key="index" :document="document"></Document>
            </div>
          </div>
        </div>
        <div class="dashboard__grid dashboard__alert alert alert-warning" v-else>
          <div class="dashboard__no-data">No pricing information available</div>
        </div>
      </div>
      <div class="dashboard__card-footer">
        <div class="dashboard__card-link" v-if="pricingVendors">
          <router-link to="/pricing-guides" class="dashboard__card-link-text">Browse Pricing Guides</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import CardLoading from './CardLoading.vue';
  import Document from '../fuel-resources/Document.vue';

  export default {
    name: 'PricingGuidesCard',
    components: {
      CardLoading,
      Document,
    },
    computed: {
      ...mapGetters('main', ['rm']),
      ...mapGetters('fuelResources', ['loaders', 'initializers', 'pricingVendors']),
    },
    mounted() {
      if (!this.initializers.documents) {
        this.$store.dispatch('fuelResources/getVendors');
      }
    },
  };
</script>
